import { render, staticRenderFns } from "./yxintroduce.vue?vue&type=template&id=3e58026a&scoped=true"
import script from "./yxintroduce.vue?vue&type=script&lang=js"
export * from "./yxintroduce.vue?vue&type=script&lang=js"
import style0 from "./yxintroduce.vue?vue&type=style&index=0&id=3e58026a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e58026a",
  null
  
)

export default component.exports